// native
import { Injectable } from '@angular/core';

// models
import { IDisplayItem } from '../../models';

// service
import { GlobalsService } from './globals.service';

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  constructor(
    private globalsService: GlobalsService
  ) { }

  viewArticleByDoi(item: IDisplayItem) {
    const url = `${this.globalsService.appConfig.environment.baseUrls.readcube}/articles/${item.ext_ids.doi}`;
    window.open(url, '_blank');
  }

  viewArticle(item: IDisplayItem) {
    const url = `${this.globalsService.appConfig.environment.baseUrls.readcube}/library/${item.collection_id}:${item.id}`;
    window.open(url, '_blank');
  }

  viewReference(item: IDisplayItem) {
    const viewUrl = `${this.globalsService.appConfig.environment.baseUrls.app}/library/${item.collection_id}/all/(sidepanel:details)?item_id=${item.id}&collection_id=${item.collection_id}`;
    window.open(viewUrl, '_blank');
  }

  editReference(item: IDisplayItem) {
    const editUrl = `${this.globalsService.appConfig.environment.baseUrls.app}/library/${item.collection_id}/all/(sidepanel:edit)?item_id=${item.id}&collection_id=${item.collection_id}`;
    window.open(editUrl, '_blank');
  }
}